import { Directive, Resolver, Query, Ctx } from 'type-graphql'
import { getRepository } from '@things-factory/shell'
import { Kpi } from '../kpi/kpi'
import { KpiValue } from '../kpi-value/kpi-value'
import { KpiAlert } from './kpi-alert-type'

@Resolver()
export class KpiAlertQuery {
  @Directive('@privilege(category: "kpi", privilege: "query", domainOwnerGranted: true, superUserGranted: true)')
  @Query(returns => [KpiAlert], { description: 'KPI 실적/등급/목표 미달 등 경고/알림 리스트 반환' })
  async kpiAlerts(@Ctx() context): Promise<KpiAlert[]> {
    const { domain } = context.state
    // 1. KPI 전체 조회
    const kpis = await getRepository(Kpi).find({ where: { domain: { id: domain.id } } })
    // 2. KPI별 최신 실적값 조회
    const alerts: KpiAlert[] = []
    for (const kpi of kpis) {
      const value = await getRepository(KpiValue).findOne({
        where: { domain: { id: domain.id }, kpi: { id: kpi.id } },
        order: { valueDate: 'DESC' }
      })
      if (!value) {
        alerts.push({
          id: `${kpi.id}-no-value`,
          kpi,
          message: `${kpi.name} 실적값 미입력`,
          level: 'info',
          createdAt: new Date()
        })
        continue
      }
      // 목표값(예: kpi.vizMeta?.targetValue) 기준 경고
      const target = kpi.vizMeta?.targetValue
      if (target !== undefined && value.value < target) {
        alerts.push({
          id: `${kpi.id}-target-miss`,
          kpi,
          message: `${kpi.name} 실적(${value.value})이 목표(${target}) 미달`,
          level: 'warning',
          createdAt: new Date()
        })
      }
      // 등급 기준 경고(예: 최하위 등급)
      // if (kpi.grades?.length) {
      //   const grade = kpi.grades.find(g => value.value >= g.minValue && value.value <= g.maxValue)
      //   if (grade && grade.score !== undefined && grade.score <= 2) {
      //     alerts.push({
      //       id: `${kpi.id}-grade-low`,
      //       kpi,
      //       message: `${kpi.name} 등급(${grade.name})(${grade.score}점)`,
      //       level: 'critical',
      //       createdAt: new Date()
      //     })
      //   }
      // }
    }
    return alerts
  }
}
